import axios from 'axios'
import {refreshToken, revokeRefreshToken} from '../../app/modules/auth/apis'
import {
  getBasicAuthorization,
  getRefreshToken,
  getToken,
  removeDataLogin,
  setUserInfo,
} from '../../app/modules/auth/helpers'
import {getConfig} from '../../_metronic/i18n/Metronici18n'

const REQUEST_URL = process.env.REACT_APP_REQUEST_URL || ''
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const service = axios.create({
  baseURL: REQUEST_URL,
  // baseURL: 'http://localhost:8080/',
  timeout: 600000,
   headers: {
    'User-Agent': navigator.userAgent,
    'Referer': window.location.href,
    'Origin': window.location.origin,
    'Sec-Fetch-Site': 'same-origin',
    'Sec-Fetch-Mode': 'cors',
    'Sec-Fetch-Dest': 'empty',
  },
  withCredentials: true 
})

service.interceptors.request.use(
  (config) => {
    const isToken = (config.headers || {}).isToken === false
    if (getToken() && !isToken) {
      config.headers['Authorization'] = getBasicAuthorization()
    }
    config.headers['Language'] = getConfig().selectedLang
    if (config.method === 'get' && config.params) {
      let url = config.url + '?'
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName]
        var part = encodeURIComponent(propName) + '='
        if (value !== null && typeof value !== 'undefined') {
          if (typeof value === 'object') {
            for (const key of Object.keys(value)) {
              let params = propName + '[' + key + ']'
              var subPart = encodeURIComponent(params) + '='
              url += subPart + encodeURIComponent(value[key]) + '&'
            }
          } else {
            url += part + encodeURIComponent(value) + '&'
          }
        }
      }
      url = url.slice(0, -1)
      config.params = {}
      config.url = url
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  (res) => {
    return res.data
  },
  async (error) => {
    console.error(" AXIOS ERROR:", error); 
    const originalConfig = error.config
    if (error.response.status === 401 && !originalConfig._retry) {
      originalConfig._retry = true
      try {
        if (getToken() && getRefreshToken()) {
          let data = {
            accessToken: getToken(),
            refreshToken: getRefreshToken(),
          }
          const refreshTokenResponse: any = await refreshToken(data)
          if (refreshTokenResponse && !refreshTokenResponse.isError) {
            let token = {
              userId: refreshTokenResponse.userId,
              accessToken: refreshTokenResponse.accessToken,
              refreshToken: refreshTokenResponse.refreshToken,
            }
            setUserInfo(JSON.stringify(token))
            service.defaults.headers.common['Authorization'] =
              'Bearer ' + refreshTokenResponse.accessToken
          } else {
            removeDataLogin()
            window.location.href = '/auth/login'
            return service(originalConfig)
          }
          return service(originalConfig)
        } else {
          removeDataLogin()
          window.location.href = '/auth/login'
        }
      } catch (_error: any) {
        removeDataLogin()
        window.location.href = '/auth/login'
        if (_error.response && _error.response.data) {
          return Promise.reject(_error.response.data)
        }
        return Promise.reject(_error)
      }
    }
    // if (error.response.status === 401) {
    //   if(getToken() && getRefreshToken()) {
    //     let data = {
    //       accessToken: getToken(),
    //       refreshToken: getRefreshToken(),
    //     }
    //     return await refreshToken(data)
    //       .then((res: any) => {
    //         if (res && !res.isError) {
    //           let token = {
    //             userId: res.userId,
    //             accessToken: res.accessToken,
    //             refreshToken: res.refreshToken,
    //           }
    //           setUserInfo(JSON.stringify(token))
    //           error.response.config.headers['Authorization'] = 'Bearer ' + res.accessToken
    //           return axios(error.response.config)
    //         }
    //       })
    //       .catch((err) => err)
    //   } else {
    //     window.location.href = '/auth/login'
    //   }
    // }

    return Promise.reject(error)
  }
)

export default service
